import {
  GET_PRODUCTCOMPLAIN,
  GET_PRODUCTCOMPLAIN_SUCCESS,
  GET_PRODUCTCOMPLAIN_FAIL,
  DELETE_PRODUCTCOMPLAIN,
  DELETE_PRODUCTCOMPLAIN_SUCCESS,
  DELETE_PRODUCTCOMPLAIN_FAIL,
  UPDATE_PRODUCTCOMPLAIN,
  UPDATE_PRODUCTCOMPLAIN_SUCCESS,
  UPDATE_PRODUCTCOMPLAIN_FAIL,
  ADD_NEW_PRODUCTCOMPLAIN,
  ADD_PRODUCTCOMPLAIN_SUCCESS,
  ADD_PRODUCTCOMPLAIN_FAIL,
  PRODUCTCOMPLAIN_LOADING,
  PRODUCTCOMPLAIN_RESET,
} from "./actionType";

export const resetProductComplainState = (actionType) => ({
  type: PRODUCTCOMPLAIN_RESET,
  payload: { actionType },
});

export const getProductComplainSuccess = (actionType, data) => ({
  type: GET_PRODUCTCOMPLAIN_SUCCESS,
  payload: { actionType, data },
});

export const getProductComplainFail = (actionType, error) => ({
  type: GET_PRODUCTCOMPLAIN_FAIL,
  payload: { actionType, error },
});

export const getProductComplain = data => ({
  type: GET_PRODUCTCOMPLAIN,
  payload: data,
});

export const getProductComplainLoading = () => ({
  type: PRODUCTCOMPLAIN_LOADING
});

export const deleteProductComplain = data => ({
  type: DELETE_PRODUCTCOMPLAIN,
  payload: data,
});

export const deleteProductComplainSuccess = data => ({
  type: DELETE_PRODUCTCOMPLAIN_SUCCESS,
  payload: data,
});

export const deleteProductComplainFail = error => ({
  type: DELETE_PRODUCTCOMPLAIN_FAIL,
  payload: error,
});

export const updateProductComplain = data => ({
  type: UPDATE_PRODUCTCOMPLAIN,
  payload: data,
});

export const updateProductComplainFail = error => ({
  type: UPDATE_PRODUCTCOMPLAIN_FAIL,
  payload: error,
});

export const updateProductComplainSuccess = data => ({
  type: UPDATE_PRODUCTCOMPLAIN_SUCCESS,
  payload: data,
});

export const addNewProductComplain = data => ({
  type: ADD_NEW_PRODUCTCOMPLAIN,
  payload: data,
});

export const addProductComplainSuccess = data => ({
  type: ADD_PRODUCTCOMPLAIN_SUCCESS,
  payload: data,
});

export const addProductComplainFail = error => ({
  type: ADD_PRODUCTCOMPLAIN_FAIL,
  payload: error,
});